/* unplugin-vue-components disabled */import script from "./tagDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./tagDialog.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__